import React from 'react';
import { withRouter } from 'react-router-dom';
import BodyContainer from '../bodyContainer/BodyContainer';
import {
  SearchInput,
  Loader,
  CELL_CLASSES,
  CELL_RENDERERS,
  ROW_SELECTION,
  TableHeader,
  TableContent,
  TableContainer,
  TableColumnDndContainer,
  TextRenderer,
  classNamePrefix
} from 'cdk-radial';
import CMFSelector from './CMFSelector';
import { AgGridReact } from 'ag-grid-react';
import './styles/selectLocations.scss';
import { connect } from 'react-redux';
import {
  addLocation,
  addLocationWithCMFNumber,
  removeLocation,
  removeLocationWithCMFNumber,
  addAllLocations,
  addAllLocationsWithCMFNumber,
  removeAllLocations,
  removeAllLocationsWithCMFNumber,
  checkDataRightsSigned,
  removeLocationFromConsentInfo,
  removeAllLocationsFromConsentInfo,
  checkAppTermsSigned,
  checkAddendumsSigned,
  checkIsLocationAlreadySubscribedToApp,
  pauseLoadingStateOfSubscribedToAppPending,
  clearSelectLocations,
  checkIsLocationAlreadySubscribedToAppFromBackend
} from '../../../../redux/connectedComponent/selectedLocations/selectedLocations.slice';
import { sendAmplitudeData } from '../../../../utils/amplitude';
import { AMPLITUDE_EVENTS, AMPLITUDE_PROPERTIES } from '../../../../constants/amplitudeConstants';

import { setAllLocationsAfterMergingCMFs } from '../../../../redux/connectedComponent/loginDetails/loginDetails.slice';
import { mergeLocations } from '../../../../utils/location';
import { CMF_STATUS } from '../../../../constants/constants';

const SEARCH_INPUT_SIZE = 'standard';

const headerProps = {
  className: '',
  dataTestId: `select-locations-table-header`,
  hideBorder: false,
  hideTableTitle: false,
  id: `select-locations-table-header`,
  isAlwaysExpanded: false,
  isDownloadable: false,
  isPrintable: false,
  isSearchable: false
};


const SEARCH_INPUT_STYLE = {
  width: 'calc(min(70vw, 794px))',
  height: '48px',
  margin: 'auto'
};

function getLocationAddress(locationObj) {
  const address = locationObj.addresses || [];
  return address[0] && address[0].streetAddress + ', ' + address[0].city;
}

class SelectLocations extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      searchInput: '',
      cardStyle: {},
      showSelectAll: true,
      selectAllChecked: false,
      solutionId:
        this.props.match &&
        this.props.match.params &&
        this.props.match.params.solutionId,
      columns: [{
        cellClass: CELL_CLASSES.CHECKBOX,
        checkboxSelection: true,
        field: 'dealershipLocationSelection',
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        headerClass: [CELL_CLASSES.CHECKBOX, CELL_CLASSES.SELECT_ALL],
        headerName: '',
        maxWidth: 55,
        minWidth: 55,
        resizable: false,
        cellRenderer: locationData => {
          const entityId = locationData && locationData.data && locationData.data.entityId;
          if (this.props.selectedLocations.includes(entityId)) {
            locationData.node.setSelected(true);
          }
        },
        cellStyle: locationData => {
          if (!this.props.isRemoveLocations) {
            let entityId = locationData && locationData.data && locationData.data.entityId;
            if (
              this.props.alreadySubscribedLocations.includes(entityId) ||
              this.props.pendingSubscriptionForLocations.includes(entityId) ||
              this.props.locationsSubscribedFromBackend?.includes(entityId)
            ) {
              locationData.node.setSelected(true);
              return {'pointer-events': 'none', opacity: '0.4', cursor: 'no-drop' };
            }
          }
        }
        }, {
        cellRenderer: CELL_RENDERERS.TEXT,
        field: 'location',
        headerName: 'Dealership Location',
        minWidth: this.props.isBulkSubscribed ? 470 : 300
      },
      {
        cellRenderer: CELL_RENDERERS.TEXT,
        field: 'address',
        headerName: 'Address',
        minWidth: 50,
        width: this.props.isBulkSubscribed ? 320 : 370
      },
      {
        cellRendererFramework: CMFSelector,
        field: 'cmfNumber',
        headerName: 'CMF Number',
        width: 170,
        customProps: 'custom',
        hide: !!this.props.isBulkSubscribed
      }],
      locationAndSelectedCMF: {},
      locationsData: [],
      locations: [],
      frameworkComponentsExtended: {
        textRenderer: TextRenderer
      }
    };
    this.handleLocationSelection = this.handleLocationSelection.bind(this);
  }

  componentDidMount() {
    if (this.props.selectedLocations && !this.props.selectedLocations.length) {
      const solutionId = this.props.solutionId || this.state.solutionId;
      if (this.props &&
        this.props.allLocationsWithDetails &&
        this.props.allLocationsWithDetails.length && !this.props.isBulkSubscribed && !this.props.isAppNotListed
      ) {
        const chunkSize = 100;
        for (let i = 0; i < this.props.allLocationsWithDetails.length; i += chunkSize) {
          const chunk = this.props.allLocationsWithDetails.slice(i, i + chunkSize);
          this.props.checkIsLocationAlreadySubscribedToApp({
            locations: chunk,
            solutionId: solutionId,
            token: this.props.token
          });

          if (!this.props.isRemoveLocations) {
            this.props.checkIsLocationAlreadySubscribedToAppFromBackend({
              locations: chunk,
              solutionId: solutionId,
              token: this.props.token
            });
          }
        }
      } else {
        this.props.pauseLoadingStateOfSubscribedToAppPending()
      }
    }
  }

  mapLocationsToTable(allLocationsWithDetails = [], locationsDataWithoutMergedCMFs = []) {
  // Helper function to filter locations based on search input
  const filterBySearchInput = (locations) => {
    if (!locations) return [];
    if (!Array.isArray(locations)) return [];
    
    const lcInput = this.state.searchInput.toLowerCase();
    return locations.filter(location => {
      // Match on location name
      if (location.partyName.toLowerCase().includes(lcInput)) {
        return true;
      }
      
      // Match on CMF number(s)
      const cmfNumbers = Array.isArray(location.cmfNumber) 
        ? location.cmfNumber 
        : [location.cmfNumber];
      
      const cmfMatch = cmfNumbers.some(cmf => 
        cmf && cmf.toString().toLowerCase().includes(lcInput)
      );

      if (!cmfMatch) return false;

      // If the location is already subscribed, only include it when searching for its subscribed CMF
      // Build a mapping of subscribed location -> subscribed CMF based on parallel arrays
      const { alreadySubscribedLocations = [], alreadySubscribedCMFs = [] } = this.props;
      let subscribedCMFForLocation;
      if (alreadySubscribedLocations.length && alreadySubscribedCMFs.length) {
        const idx = alreadySubscribedLocations.indexOf(location.entityId);
        if (idx !== -1) {
          subscribedCMFForLocation = alreadySubscribedCMFs[idx];
        }
      }

      if (subscribedCMFForLocation) {
        // If user is searching a CMF that does NOT correspond to the subscribed CMF, suppress this row
        const subscribedCmfStr = subscribedCMFForLocation.toString().toLowerCase();
        if (!subscribedCmfStr.includes(lcInput)) {
          return false;
        }
      }

      return true;
    });
  };

  // Helper function to create location table row
  const createLocationRow = (locationObj, isRemoveMode = false) => {
    const fullAddress = getLocationAddress(locationObj);
    const isSubscribed = this.props.alreadySubscribedLocations.includes(locationObj.entityId) ||
      this.props.pendingSubscriptionForLocations.includes(locationObj.entityId) ||
      (this.props.isBulkSubscribed || this.props.isAppNotListed) && 
        this.props.subscriptionData?.some(sub => sub.entityId === locationObj.entityId) ||
      this.props.locationsSubscribedFromBackend?.includes(locationObj.entityId);

    const subscribedCMFs = this.props.isAppNotListed
      ? this.props.subscriptionData?.map(sub => sub.entitycmfNumber) || []
      : this.props.alreadySubscribedCMFs.concat(this.props.pendingSubscriptionCMFs);

    const cmfData = Array.isArray(locationObj.cmfNumber)
      ? locationObj.cmfNumber.map(cmfNumber => ({ label: cmfNumber, value: cmfNumber }))
      : [{ label: locationObj.cmfNumber, value: locationObj.cmfNumber }];

    return {
      entityId: locationObj.entityId,
      location: locationObj.partyName,
      address: fullAddress,
      storeId: locationObj.storeId,
      cmfNumber: {
        setDefaultCMF: isRemoveMode 
          ? () => {} 
          : (entityId, defaultCMFNumber) => {
              this.setState(prev => ({
                locationAndSelectedCMF: {
                  ...prev.locationAndSelectedCMF,
                  [entityId]: defaultCMFNumber
                }
              }));
            },
        onCMFSelected: isRemoveMode
          ? () => {}
          : (entityId, location, address, cmfNumber) => {
              this.setState(prev => ({
                locationAndSelectedCMF: {
                  ...prev.locationAndSelectedCMF,
                  [entityId]: cmfNumber
                }
              }));
            if (this.props.selectedLocations.includes(entityId)) {
              this.handleLocationSelection(
                entityId, 
                location, 
                address, 
                cmfNumber, 
                true, 
                'CMF_NUMBER_GOT_CHANGED',
                locationObj.storeId
              );
            }
            },
        location: locationObj.partyName,
        entityId: locationObj.entityId,
        address: fullAddress,
        isRemoveLocations: isRemoveMode,
        isSubscribed,
        subscribedCMFs,
        cmfData,
        columnId: locationObj.entityId
      }
    };
  };

  // Filter based on search input
  allLocationsWithDetails = filterBySearchInput(allLocationsWithDetails);

  if (this.props.isRemoveLocations) {
    let subscribedLocations;
    
    if (this.props.isBulkSubscribed || this.props.isAppNotListed) {
      const subscribedEntities = this.props.subscriptionData?.map(sub => sub.entityId) || [];
      subscribedLocations = allLocationsWithDetails?.filter(location => 
        subscribedEntities.includes(location.entityId)
      );
    } else {
      subscribedLocations = allLocationsWithDetails?.filter(location => 
        this.props.alreadySubscribedLocations.includes(location.entityId) || 
        this.props.locationsSubscribedFromBackend?.includes(location.entityId)
      );
    }

    return subscribedLocations?.map(location => 
      createLocationRow(location, true)
    ) || [];
  } else {
    // Filter inactive subscribed and active unsubscribed locations
    if (!locationsDataWithoutMergedCMFs || !locationsDataWithoutMergedCMFs.length) {
      locationsDataWithoutMergedCMFs = allLocationsWithDetails || [];
    }
    locationsDataWithoutMergedCMFs = (locationsDataWithoutMergedCMFs || []).filter(e => {
      const isSubscribed = this.props.alreadySubscribedLocations.includes(e.entityId) ||
        this.props.pendingSubscriptionForLocations.includes(e.entityId) ||
        this.props.locationsSubscribedFromBackend?.includes(e.entityId);
      
      return (e.status === CMF_STATUS.INACTIVE && isSubscribed) || 
             (e.status === CMF_STATUS.ACTIVE);
    });

    const locationsDataWithMergedCMFs = filterBySearchInput(
      mergeLocations(locationsDataWithoutMergedCMFs || [])
    );

    return locationsDataWithMergedCMFs?.map(location => 
      createLocationRow(location)
    ) || [];
  }
}

  handleInputChange(input) {
    this.setState({
      searchInput: input
    });
  }

  handleLocationSelection(entityId, location, address, cmfNumber, addition, trigger, storeId) {
    const allLocationsCMFandEntityId = this.props.allLocationsWithDetails;
    const entityObject =
      allLocationsCMFandEntityId &&
      allLocationsCMFandEntityId.filter(
        locationObject => locationObject.entityId === entityId
      )[0];

    sendAmplitudeData(AMPLITUDE_EVENTS.REMOVE_LOCATIONS_CHECKBOX, {
      [AMPLITUDE_PROPERTIES.APP_ID]: this.state.solutionId,
      [AMPLITUDE_PROPERTIES.ORG_ID]: entityId,
      [AMPLITUDE_PROPERTIES.ORG_NAME]: location,
      [AMPLITUDE_PROPERTIES.ORG_CMF]: entityObject?.cmfNumber
    });

    if (addition) {
      if (this.props.selectedLocations.includes(entityId)) {
        if (trigger === 'CMF_NUMBER_GOT_CHANGED') {
          this.props.removeLocation(entityId);
          this.props.removeLocationWithCMFNumber(entityId);
          this.props.removeLocationFromConsentInfo(entityId);
        }
        else return;
      }
      this.props.addLocation(entityId);
      //check if the selected location has consented to data rights
      const token = this.props.token;

      const selectedLocationCMFNumber = cmfNumber || this.state.locationAndSelectedCMF[entityId];

      this.props.addLocationWithCMFNumber({
        location,
        cmfNumber: selectedLocationCMFNumber,
        entityId,
        address,
        storeId
      });

      if(!selectedLocationCMFNumber) return;

      //check if selected locations have consented to data rights
      if (this.props.doesAppRequireDataRights) {
        this.props.checkDataRightsSigned({
          location,
          entityId,
          selectedLocationCMFNumber,
          token
        });
      }

      let solutionId = this.state.solutionId;

      this.props.checkAddendumsSigned({ solutionId, location, entityId, token });
      if (this.props.activateOnly === false) {
        this.props.checkAppTermsSigned({ solutionId, location, entityId, selectedLocationCMFNumber, token });
      }
    } else {
      this.props.removeLocation(entityId);
      this.props.removeLocationWithCMFNumber(entityId);
      this.props.removeLocationFromConsentInfo(entityId);
    }
  }

  componentDidUpdate() {
    if (this.props.selectedLocations && !this.props.selectedLocations.length) {
        this.props.disableNextButton(true);
    } else {
      let numberOfSelectedLocations = this.props.selectedLocations.length;
      let selectedLocationsWithCMFNumber = this.props.selectedLocationsWithCMFNumber || [];
      let cmfNumbers = selectedLocationsWithCMFNumber.filter(location => location.cmfNumber).length;
      if(numberOfSelectedLocations !== cmfNumbers) {
        this.props.disableNextButton(true);
      }
      else {
        this.props.disableNextButton(false);
      }
    }
  }

  render() {
    let isPending = this.props.isSolutionInfoPending || this.props.isCheckLocationAlreadySubscribedToAppPending || this.props.numberOfRequests || this.props.hideLocations || this.props.isCheckLocationAlreadySubscribedToAppFromBackendPending;
    return (
        <BodyContainer title={this.props.title || this.props.constants.TITLE} description={this.props.description || this.props.constants.DESCRIPTION}>
          <div className="select-locations-body">
            <SearchInput
              name="select-locations-search-input"
              id="select-locations-search-input"
              isAlwaysExpanded
              placeholder={this.props.constants.SEARCH_DEALERSHIP_LOCATIONS}
              style={SEARCH_INPUT_STYLE}
              onChange={input => this.handleInputChange(input)}
              size={SEARCH_INPUT_SIZE}
              value={this.state.searchInput}
            />
            <div style={{ paddingTop: '25px' }} className={!isPending && 'table-container'}>
              {isPending ? (
                  <div className="select-locations-loader">
                    <Loader label="Fetching Locations..." />
                  </div>
                ) : (
                  <TableContainer className={`${classNamePrefix}-table ag-theme-balham select-locations-table ${this.props.isRemoveLocations && (this.props.isBulkSubscribed  ? 'select-locations-table-remove-locations-noCmf'  : 'select-locations-table-remove-locations')}`} >
                      <TableHeader {...headerProps} />
                      <TableContent data-testid="table-content">
                        <AgGridReact
                          frameworkComponents={this.state.frameworkComponentsExtended}
                          columnDefs={this.state.columns}
                          rowData={this.mapLocationsToTable(this.props.allLocationsWithDetails, this.props.allLocationsWithoutMergingCmfs)}
                          rowSelection={ROW_SELECTION.MULTIPLE}
                          rowHeight={50}
                          onRowSelected={data => {

                            let rowData = data && data.data;
                            const location = rowData.location;
                            const entityId = rowData.entityId;
                            const storeId = rowData.storeId;
                            let addition = data && data.node && data.node.selected && true;

                            if(this.props.isRemoveLocations) {
                              this.props.customHandlerForLocationSelection(entityId, addition && 'addition', this.props.alreadySubscribedLocations);
                              return;
                            }

                            //override deselection of row by select all checkbox for subscribed locations
                            if (
                              this.props.alreadySubscribedLocations.includes(entityId) ||
                              this.props.pendingSubscriptionForLocations.includes(entityId) ||
                              this.props.numberOfRequests ||
                              this.props.locationsSubscribedFromBackend?.includes(entityId)
                            ) {
                              data.node.setSelected(true);
                              return;
                            }

                            let cmfData = rowData.cmfNumber && rowData.cmfNumber.cmfData;
                            //in case of multiple cmf numbers, fall over to the selected cmf for that location
                            let cmfNumber;
                            if(cmfData && cmfData.length > 1) {
                              cmfNumber = this.state.locationAndSelectedCMF[entityId];
                            }
                            else {
                              cmfNumber = cmfData && cmfData[0] && cmfData[0].value
                            }
                            // Passing null as 'trigger' to indicate no specific trigger
                            this.handleLocationSelection(entityId, location, rowData.address, cmfNumber, addition, null, storeId);
                          }}
                          suppressRowClickSelection={true}
                          />
                      </TableContent>
                      <TableColumnDndContainer />
                    </TableContainer>
                )}
            </div>
          </div>
        </BodyContainer>
    );
  }
}

const mapStateToProps = state => ({
  selectedLocations:
    state &&
    state.selectLocationsSlice &&
    state.selectLocationsSlice.selectedLocations,
  token:
    state &&
    state.loginDetailsSlice &&
    state.loginDetailsSlice.authenticationToken,
  alreadySubscribedLocations:
    state &&
    state.selectLocationsSlice &&
    state.selectLocationsSlice.alreadySubscribedLocations,
  pendingSubscriptionForLocations:
    state &&
    state.selectLocationsSlice &&
    state.selectLocationsSlice.pendingSubscriptionForLocations,
  doesAppRequireDataRights:
    state &&
    state.solutionInfoSlice &&
    state.solutionInfoSlice.captureDataRights,
  numberOfRequests:
    state &&
    state.selectLocationsSlice &&
    state.selectLocationsSlice.numberOfRequests,
  alreadySubscribedCMFs:
    state &&
    state.selectLocationsSlice &&
    state.selectLocationsSlice.alreadySubscribedCMFs,
  pendingSubscriptionCMFs:
    state &&
    state.selectLocationsSlice &&
    state.selectLocationsSlice.pendingSubscriptionCMFs,
  selectedLocationsWithCMFNumber:
    state &&
    state.selectLocationsSlice &&
    state.selectLocationsSlice.selectedLocationsWithCMFNumber,
  constants:
    state &&
    state.solutionInfoSlice &&
    state.solutionInfoSlice.constants,
  activateOnly:
    state && state.solutionInfoSlice && state.solutionInfoSlice.solutionInfo.activateOnly,
  locationsSubscribedFromBackend:
    state &&
    state.selectLocationsSlice &&
    state.selectLocationsSlice.locationsSubscribedFromBackend,
});

const mapDispatchToProps = {
  addLocation,
  addLocationWithCMFNumber,
  removeLocation,
  removeLocationWithCMFNumber,
  addAllLocations,
  addAllLocationsWithCMFNumber,
  removeAllLocations,
  removeAllLocationsWithCMFNumber,
  checkDataRightsSigned,
  removeLocationFromConsentInfo,
  removeAllLocationsFromConsentInfo,
  checkAppTermsSigned,
  checkAddendumsSigned,
  checkIsLocationAlreadySubscribedToApp,
  clearSelectLocations,
  pauseLoadingStateOfSubscribedToAppPending,
  setAllLocationsAfterMergingCMFs,
  checkIsLocationAlreadySubscribedToAppFromBackend
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SelectLocations)
);
